export default "__VITE_ASSET__DfTphd6r__"